import { gql } from "@apollo/client";
import { Locale } from "@common/constans";

export const GET_LANGUAGE_BY_COUNTRY_CODE = gql`
  query GetLanguage($code: String = "") {
    country(where: {code: {code: $code}, localization: {culture: "${Locale.en}"}}) {
      language
    }
  }
`
